import { Divider, Grid } from '@material-ui/core';
import BigNumber from 'bignumber.js';
import { SSTSummaryComponent } from 'components/Footer/SSTSummary';
import { TaxSchemeComponent } from 'components/Footer/TaxSchemeComponent';
import { PaymentClass } from 'generated/graphql';
import { toProperCase } from 'helpers/hooks/stringNumberFunction/stringConverter';
import { amtStr } from 'helpers/numFormatter';
import React from 'react';
const dateFormat = require('dateformat');

const formatMoney = (currencyCode: string, value: number) =>
	`${currencyCode || ''}${Number(value || 0).toLocaleString('en-MY', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;

export const BillFooterReceipt = (props: any) => {
	const {
		total,
		discount,
		subtotal,
		mode,
		query,
		latestPayment,
		currencyCode = '',
		outletID,
		order,
		orderID,
		taxSchemeInfo,
		taxSchemeFooterInfo,
	} = props;

	const payments = Array.isArray(latestPayment)
		? latestPayment
		: latestPayment
		? [latestPayment]
		: [];

	const handleCardType = cardType => {
		switch (cardType) {
			case 'VISA_CARD':
				return 'VISA';
			case 'MASTERCARD':
				return 'MASTERCARD';
			case 'AMERICAN_EXPRESS_CARD':
				return 'AMERICAN EXPRESS';
			case 'DINERS_CARD':
				return 'DINERS';
			case 'JCB_CARD':
				return 'JCB';
			case 'UNIONPAY_CARD':
				return 'UNIONPAY';
			case 'DEBIT_CARD':
				return 'DEBIT';
			default:
				return 'Credit';
		}
	};

	let roundAmount = 0;
	payments?.forEach(x => {
		roundAmount += x?.roundingAmount || 0;
	});

	const company = query?.[0]?.outlet?.company;
	const qrCodeUrl = query?.[0]?.qrCodeUrl;
	const Einvoice = qrCodeUrl !== null && query?.[0]?.is_einvoice === true;

	const customerInfo = (() => {
		try {
			return JSON.parse(localStorage.getItem('customerInfo') || '{}');
		} catch {
			return {};
		}
	})();

	const eInvoiceQr = () => {
		const condition =
			query?.[0]?.is_einvoice === true &&
			company?.isEInvIntegrated === true &&
			dateFormat(query?.[0]?.createdTs, 'yyyy-mm-dd') >=
				dateFormat(company?.eInvStartDate, 'yyyy-mm-dd') &&
			dateFormat(query?.[0]?.createdTs, 'yyyy-mm-dd') <=
				dateFormat(company?.eInvEndDate, 'yyyy-mm-dd') &&
			qrCodeUrl !== null;

		const eInvoice3rdParty = query?.[0]?.outlet?.integrate3rdPartyeInvoice;
		const uuid = query?.[0]?.einvoice_irbm_uniqueID ?? '-';

		if (!(condition === true && eInvoice3rdParty === false) &&
			!(condition === true && eInvoice3rdParty === true)) {
			return null;
		}

		return (
			<>
				<div className="dialog-dynamic-content">
					<div className="session">
						<div className="flex session">
							<div
								className="flex-space xsTitle"
								style={{
									alignSelf: 'center',
									fontSize: '16px',
									color: '#212121',
									textAlign: 'center',
								}}
							>
								<img
									src={qrCodeUrl}
									alt="QR Code"
									style={{ width: '85px', display: 'inline-block' }}
								/>
							</div>
						</div>
					</div>
				</div>
				<div style={{ width: '100%', lineHeight: 1 }}>
					{eInvoice3rdParty === true ? (
						<>
							<span
								style={{
									fontSize: '9px',
									display: 'flex',
									justifyContent: 'center',
									textAlign: 'center',
								}}
							>
								If e-invoice is required,
							</span>
							<span
								style={{
									fontSize: '9px',
									display: 'flex',
									justifyContent: 'center',
									textAlign: 'center',
								}}
							>
								please scan the QR code within
							</span>
							<span
								style={{
									fontSize: '9px',
									display: 'flex',
									justifyContent: 'center',
									textAlign: 'center',
								}}
							>
								the calendar month of your purchase
							</span>
						</>
					) : (
						<>
							<span
								style={{
									fontSize: '9px',
									display: 'flex',
									justifyContent: 'center',
									textAlign: 'center',
								}}
							>
								Scan within 72 hours if
							</span>
							<span
								style={{
									fontSize: '9px',
									display: 'flex',
									justifyContent: 'center',
									textAlign: 'center',
								}}
							>
								e-Invoice is required
							</span>
							<span
								style={{
									fontSize: '9px',
									display: 'flex',
									justifyContent: 'center',
									textAlign: 'center',
								}}
							>
								UUID : {uuid}
							</span>
						</>
					)}
				</div>
			</>
		);
	};

	return (
		<>
			<div className="dialog-dynamic-content" style={{ marginTop: '10px' }}>
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{'Sub-Total'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{formatMoney(currencyCode, subtotal)}
						</div>
					</div>
				</div>
			</div>

			<div className="dialog-dynamic-content">
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{'Discount'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{`(${currencyCode}${amtStr(discount)})`}
						</div>
					</div>
				</div>
			</div>

			<div className="dialog-dynamic-content">
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
								height: '17px',
							}}
						>
							{'Rounding'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{roundAmount < 0
								? `(${currencyCode}${Math.abs(roundAmount).toFixed(2)})`
								: formatMoney(currencyCode, roundAmount)}
						</div>
					</div>
				</div>
			</div>

			<Divider style={{ display: 'flex', width: '100%' }} />

			<div
				className="dialog-dynamic-content"
				style={{ paddingTop: '5px', paddingBottom: '10px' }}
			>
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space xsTitle"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								paddingBottom: '5px',
								color: '#212121',
							}}
						>
							{'Total'}
						</div>
						<div className="rightText">
							<div
								className="xsTitle"
								style={{
									fontSize: '16px',
									color: '#212121',
									paddingBottom: '5px',
								}}
							>
								{formatMoney(
									currencyCode,
									new BigNumber(total || 0)
										.abs()
										.plus(roundAmount || 0)
										.toNumber(),
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<Divider style={{ display: 'flex', width: '100%' }} />

			<TaxSchemeComponent
				outletID={outletID}
				taxSchemeID={null}
				currencyCode={currencyCode}
				type={'receipt'}
				taxSchemeInfo={taxSchemeInfo || order?.taxSchemeInfo}
				taxSchemeFooterInfo={
					taxSchemeFooterInfo || order?.taxSchemeFooterInfo
				}
				takeaway={false}
				orderID={orderID || order?.ID}
			/>

			<Divider style={{ display: 'flex', width: '100%', marginTop: '10px' }} />

			{mode == 'void-bill' ? null : (
				<>
					<div className="dialog-dynamic-content" style={{ marginTop: '5px' }}>
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space xsTitle"
									style={{
										alignSelf: 'center',
										fontSize: '16px',
										color: '#212121',
									}}
								>
									{'Payment'}
								</div>
							</div>
						</div>
					</div>
					{payments?.map((x, index) => (
						<div key={x?.ID || index} style={{ width: '100%' }}>
							<table
								style={{
									width: '100%',
									borderCollapse: 'collapse',
									tableLayout: 'fixed',
									marginTop: '2px',
									marginBottom: '2px',
								}}
							>
								<tbody>
									<tr>
										<td
											style={{
												fontSize: '16px',
												color: '#212121',
												textAlign: 'left',
												verticalAlign: 'middle',
												padding: 0,
											}}
										>
											{x?.paymentClass === PaymentClass.Online
												? 'Online Payment'
												: x?.paymentClass === PaymentClass.Credit
												? handleCardType(x?.creditCardType)
												: x?.paymentClass === PaymentClass.UnsettledBill
												? 'Unsettled Bill'
												: toProperCase(x?.paymentClass)}
										</td>
										<td
											style={{
												fontSize: '16px',
												color: '#212121',
												fontWeight: 600,
												textAlign: 'right',
												verticalAlign: 'middle',
												whiteSpace: 'nowrap',
												padding: 0,
											}}
										>
											{formatMoney(
												currencyCode,
												x?.paymentClass === PaymentClass.UnsettledBill
													? x?.amount
													: x?.receivedAmount,
											)}
										</td>
									</tr>
									{(x?.paymentClass === PaymentClass.Online ||
										x?.paymentClass === PaymentClass.BankTt ||
										x?.paymentClass === PaymentClass.Cheque ||
										x?.paymentClass === PaymentClass.Member) && (
										<tr>
											<td
												style={{
													fontSize: '16px',
													color: '#212121',
													textAlign: 'left',
													verticalAlign: 'middle',
													padding: '2px 0 0',
												}}
											>
												Remark:
											</td>
											<td
												style={{
													fontSize: '16px',
													color: '#212121',
													fontWeight: 600,
													textAlign: 'right',
													verticalAlign: 'middle',
													whiteSpace: 'nowrap',
													padding: '2px 0 0',
												}}
											>
												{x?.remark ?? '-'}
											</td>
										</tr>
									)}
									{x?.paymentClass === PaymentClass.Cash &&
										x?.changeAmount > 0 && (
											<tr>
												<td
													style={{
														fontSize: '16px',
														color: '#212121',
														fontStyle: 'italic',
														textAlign: 'left',
														verticalAlign: 'middle',
														padding: '2px 0 0',
													}}
												>
													Change
												</td>
												<td
													style={{
														fontSize: '16px',
														color: '#212121',
														fontWeight: 600,
														fontStyle: 'italic',
														textAlign: 'right',
														verticalAlign: 'middle',
														whiteSpace: 'nowrap',
														padding: '2px 0 0',
													}}
												>
													{formatMoney(currencyCode, x?.changeAmount)}
												</td>
											</tr>
										)}
								</tbody>
							</table>
						</div>
					))}
				</>
			)}

			<Divider style={{ display: 'flex', width: '100%', marginTop: '10px' }} />

			<SSTSummaryComponent
				outletID={outletID}
				orderID={orderID || order?.ID}
				accountID={customerInfo?.accountID}
			/>

			{Einvoice ? eInvoiceQr() : null}

			{mode == 'void-bill' ? null : (
				<div
					className="dialog-dynamic-content"
					style={{ marginTop: '30px', marginBottom: '5px' }}
				>
					<div className="session">
						<div className="flex session">
							<div
								className="flex-space xsTitle text-noflow"
								style={{
									alignSelf: 'center',
									fontSize: '14px',
									color: '#212121',
									textAlign: 'center',
									height: '17px',
								}}
							>
								{'Thank you & we hope to see you again soon.'}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
